import { ChangeDetectionStrategy, Component, input, computed, ViewEncapsulation } from '@angular/core';
import { ProgressStatusConfigType } from './fi-progress-badge';

@Component({
    selector: 'fi-progress-badge',
    templateUrl: './fi-progress-badge.component.html',
    styleUrls: ['./fi-progress-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-progress-badge' },
})
export class FiProgressBadgeComponent<T extends number> {
    public progressStatus = input.required<T>();
    public progressStatusConfig = input.required<ProgressStatusConfigType<T>>();

    protected statusText = computed(() => {
        const config = this.progressStatusConfig()[this.progressStatus()];
        if (!config) {
            console.warn(`No status config found for status: ${this.progressStatus()}`);
            return '';
        }
        return config.textId;
    });
    protected statusClass = computed(() => {
        const config = this.progressStatusConfig()[this.progressStatus()];
        if (!config) {
            console.warn(`No status config found for status: ${this.progressStatus()}`);
            return '';
        }
        return config.statusClass;
    });
}
